import Cashback from '@pages/setting/payment/cashback';
import PaymentChanges from '@pages/setting/payment-changes/PaymentChanges';
import { decryptUserStorage } from '@reducers/UserSlice';
import { Permissions } from '@utils/constants/permissions';

import AutomaticPayment from '../../components/paymentSettings/automaticPayment/AutomaticPayment';
import PaymentWays from '../../components/paymentSettings/paymentWays/PaymentWays';
import RemotePayment from '../../components/paymentSettings/remotePayment/RemotePayment';
import Currency from '../../pages/currency/Currency';

import { PaymentSettingsPath } from './PaymentSettingsPath';

const user = decryptUserStorage;

const routes = [
  {
    path: PaymentSettingsPath.REMOTE_PAYMENT,
    component: RemotePayment,
    exact: true
  },
  {
    path: PaymentSettingsPath.AUTOMATIC_PAYMENT,
    component: AutomaticPayment,
    exact: true
  },
  {
    component: PaymentWays,
    path: PaymentSettingsPath.PAYMENT_WAYS,
    exact: false
  },
  {
    component: Currency,
    path: PaymentSettingsPath.CURRENCY,
    exact: true
  },
  {
    component: PaymentChanges,
    path: PaymentSettingsPath.FIELD,
    exact: true
  },
  {
    component: Cashback,
    path: PaymentSettingsPath.CASHBACK,
    exact: true,
    permission: Permissions.PERMISSION_CASHBACK_CONFIG
  }
];

const paymentSettingsRoutes: typeof routes = [];

if (typeof user === 'object' && user) {
  routes.forEach(route => {
    if (route.permission) {
      if (user.role?.permissions?.includes(route.permission)) {
        paymentSettingsRoutes.push(route);
      }
    } else {
      paymentSettingsRoutes.push(route);
    }
  });
}

export default paymentSettingsRoutes;
